import { useQuery } from '@tanstack/react-query';

import { reportingLeLensPath } from '~/consts/reportingLeLensApi';

import { request } from '~/services/common';

import { resolveReportingLeLensUrl } from '~/utils/resolveReportingLeLensUrl';

import { reportingLeLensQueryKeys } from './useGetReportingLeLens';

export type LensViewersDays = 7 | 30 | 90;

type LensViewersResponse = {
  days: LensViewersDays;
  viewers: Array<{ email: string; views: number; lastViewedAt: string }>;
};

export function useGetReportingLeLensViewers(lensId: string, days: LensViewersDays, open: boolean) {
  return useQuery({
    queryKey: [...reportingLeLensQueryKeys.detail(lensId), 'viewers', days],
    queryFn: async ({ signal }) =>
      (await request(resolveReportingLeLensUrl(`${reportingLeLensPath(lensId)}/viewers?days=${days}`), {
        signal,
      })) as LensViewersResponse,
    enabled: open && Boolean(lensId),
    retry: false,
  });
}
